module.exports = __webpack_public_path__ + "static/media/fcc_logo.982d2cd4.png";